import { CurrencyInputField, FormDrawer, FormDrawerContent, Id, isSuccess, useToasts } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IEventContactEndpoints } from "../../../shared/api/event/withEventContactEndpoints";
import { eventContactBaseKey } from "../../../shared/api/eventContactService";

interface Props {
	eventId: Id;
	open: boolean;
	contactId: Id;
	cost: number;
	eventContactService: IEventContactEndpoints;
	onClose: () => void;
	onClosed: () => void;
}

export const CostDrawer: FC<Props> = ({ eventId, contactId, cost, eventContactService, ...drawerProps }) => {
	const { t } = useTranslation();
	const { showToast } = useToasts();
	const queryClient = useQueryClient();

	const handleSubmit = async (values: { cost: number }) => {
		const response = await eventContactService.updateContactCost(eventId, contactId, values);

		if (isSuccess(response)) {
			showToast({
				type: "success",
				title: t("Update cost"),
				body: t("Cost updated successfully."),
			});

			void queryClient.invalidateQueries({ queryKey: eventContactBaseKey(contactId) });
			void queryClient.invalidateQueries({ queryKey: eventContactService.contactsKey(eventId) });
			void queryClient.invalidateQueries({
				predicate: (query) => query.queryKey.includes("events"),
			});

			return true;
		}

		return false;
	};

	return (
		<FormDrawer
			title={t("Update cost")}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<CurrencyInputField name="cost" label={t("Cost")} />
				</FormDrawerContent>
			)}
			initialValues={{ cost: cost }}
			onSubmit={handleSubmit}
			{...drawerProps}
		/>
	);
};
